export default "__VITE_ASSET__Dk_D3B3c__"